parseURL = require 'url-parse'

module.exports = (url) ->
  parseURL(url).host == location.host



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/is-trello.coffee